import React, { useState, useRef, useEffect } from "react";
import { departmentView } from "pages/TeamZone/TeamZoneHeaders";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { tableRowSize } from "services/constants";
import * as Mui from "@mui/material";
import { Loader } from "components/Loader";
import { themes, scrollTop } from "services/constants";
import { ArrowRight } from "@mui/icons-material";
export const ShiftWise = ({
  shiftReports,
  shiftLoading,
  setLeavePage,
  leavePage,
  headers,
}) => {
  const [expandedRow, setExpandedRow] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const containerRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);
  return shiftLoading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Paper sx={{ width: "100%", height: "77vh", overflow: "hidden" }}>
        <Mui.Grid sx={{ mx: { xs: 0, sm: 2 }, minWidth: 0 }}>
          <Mui.TableContainer
            ref={containerRef}
            sx={{ maxHeight: 590, overflowX: "auto", width: "100%" }}
          >
            <Mui.Table className="border" sx={{ minWidth: 720 }}>
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow sx={tableRowSize}>
                  <Mui.TableCell align="center" rowSpan={2} />
                  {headers?.map((header, index) => (
                    <Mui.TableCell
                      key={`${header.name}-${index}`}
                      align="center"
                      colSpan={header.children ? header.children.length : 1}
                      rowSpan={header.children ? 1 : 2}
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        border: "1px solid #ddd",
                      }}
                    >
                      {header.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>

                <Mui.TableRow sx={tableRowSize}>
                  {headers
                    ?.filter((header) => header.children)
                    ?.flatMap((header) =>
                      header.children.map((child) => (
                        <Mui.TableCell
                          key={child.key}
                          align="center"
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                            border: "1px solid #ddd",
                          }}
                        >
                          {child.name}
                        </Mui.TableCell>
                      )),
                    )}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {(shiftReports || [])?.length === 0 ? (
                  <TableEmptyState dataLength={(shiftReports || [])?.length} />
                ) : (
                  (shiftReports || [])
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage,
                    )
                    ?.map((row) => (
                      <>
                        <Mui.TableRow sx={tableRowSize}>
                          <Mui.TableCell
                            onClick={() => {
                              if (expandedRow !== row["shift_id"]) {
                                setExpandedRow(row["shift_id"]);
                              } else {
                                setExpandedRow("");
                              }
                            }}
                          >
                            <ArrowRight
                              sx={{
                                transition: "0.3s",
                                transform:
                                  expandedRow === row["shift_id"]
                                    ? "rotate(90deg)"
                                    : "rotate(0deg)",
                                cusror: "pointer",
                              }}
                            />
                          </Mui.TableCell>
                          {headers.flatMap((header) =>
                            header.children
                              ? header.children.map((child) => (
                                  <Mui.TableCell key={child.key} align="center">
                                    {typeof row[child.key] === "boolean"
                                      ? row[child.key]
                                        ? "Enabled"
                                        : "Disabled"
                                      : (row[child.key] ?? "-")}
                                  </Mui.TableCell>
                                ))
                              : [
                                  <Mui.TableCell key={header.key} align="center">
                                    {typeof row[header.key] === "boolean"
                                      ? row[header.key]
                                        ? "Enabled"
                                        : "Disabled"
                                      : (row[header.key] ?? "-")}
                                  </Mui.TableCell>,
                                ],
                          )}
                        </Mui.TableRow>
                        {expandedRow === row["shift_id"] && (
                          <Mui.TableRow
                            sx={{
                              justifyContent: "center",
                              width: "100%",
                            }}
                          >
                            <Mui.TableCell
                              style={{ padding: 1 }}
                              colSpan={100}
                              align="center"
                            >
                              <Mui.Collapse
                                in={expandedRow}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Mui.TableContainer
                                  ref={containerRef}
                                  sx={{
                                    maxHeight: 590,
                                    display: "flex",
                                    justifyContent: "center",
                                    width: "100%",
                                    overflowX: "auto",
                                  }}
                                >
                                  <Mui.Box
                                    sx={{
                                      padding: 1,
                                      width: "100%",
                                      mx: "auto", // ✅ center horizontally
                                    }}
                                  >
                                    <Mui.Table
                                      className="border"
                                      sx={{
                                        width: "100%", // ✅ full width table
                                        minWidth: 720,
                                        tableLayout: "auto", // or "fixed" if needed
                                      }}
                                    >
                                      <Mui.TableHead
                                        sx={{
                                          backgroundColor: themes.primary,
                                          position: "sticky",
                                          top: -1,
                                          zIndex: 10,
                                        }}
                                      >
                                        <Mui.TableRow sx={tableRowSize}>
                                          {departmentView.map(
                                            (header, index) =>
                                              header?.name !== "" && (
                                                <Mui.TableCell
                                                  key={`${header.name}-${index}`}
                                                  align="center"
                                                  colSpan={
                                                    header.children
                                                      ? header.children.length
                                                      : 1
                                                  }
                                                  rowSpan={
                                                    header.children ? 1 : 2
                                                  }
                                                  sx={{
                                                    color: themes.headLine,
                                                    fontWeight: "bold",
                                                    border: "1px solid #ddd",
                                                  }}
                                                >
                                                  {header.name}
                                                </Mui.TableCell>
                                              ),
                                            // : (
                                            //   <Mui.TableCell
                                            //     key={header.name}
                                            //     align="center"
                                            //     colSpan={
                                            //       header.children
                                            //         ? header.children.length
                                            //         : 1
                                            //     }
                                            //     rowSpan={
                                            //       header.children ? 1 : 2
                                            //     }
                                            //   >
                                            //     {header.name}
                                            //   </Mui.TableCell>
                                            // ),
                                          )}
                                        </Mui.TableRow>

                                        <Mui.TableRow sx={tableRowSize}>
                                          {departmentView
                                            .filter((header) => header.children)
                                            .flatMap((header) =>
                                              header.children.map((child) => (
                                                <Mui.TableCell
                                                  key={child.key}
                                                  align="center"
                                                  sx={{
                                                    color: themes.headLine,
                                                    fontWeight: "bold",
                                                    border: "1px solid #ddd",
                                                  }}
                                                >
                                                  {child.name}
                                                </Mui.TableCell>
                                              )),
                                            )}
                                        </Mui.TableRow>
                                      </Mui.TableHead>
                                      <Mui.TableBody>
                                        {row?.department_data?.length === 0 ? (
                                          <TableEmptyState
                                            dataLength={
                                              row?.department_data?.length
                                            }
                                          />
                                        ) : (
                                          row?.department_data
                                            ?.slice(
                                              page * rowsPerPage,
                                              page * rowsPerPage + rowsPerPage,
                                            )
                                            ?.map((row) => (
                                              <>
                                                <Mui.TableRow sx={tableRowSize}>
                                                  {departmentView.flatMap(
                                                    (header) =>
                                                      header.children
                                                        ? header.children.map(
                                                            (child) => (
                                                              <Mui.TableCell
                                                                key={child.key}
                                                                align="center"
                                                              >
                                                                {typeof row[
                                                                  child.key
                                                                ] === "boolean"
                                                                  ? row[
                                                                      child.key
                                                                    ]
                                                                    ? "Enabled"
                                                                    : "Disabled"
                                                                  : (row[
                                                                      child.key
                                                                    ] ?? "-")}
                                                              </Mui.TableCell>
                                                            ),
                                                          )
                                                        : [
                                                            header.key !==
                                                              "" && (
                                                              <Mui.TableCell
                                                                key={header.key}
                                                                align="center"
                                                              >
                                                                {typeof row[
                                                                  header.key
                                                                ] === "boolean"
                                                                  ? row[
                                                                      header.key
                                                                    ]
                                                                    ? "Enabled"
                                                                    : "Disabled"
                                                                  : (row[
                                                                      header.key
                                                                    ] ?? "-")}
                                                              </Mui.TableCell>
                                                            ),
                                                          ],
                                                  )}
                                                </Mui.TableRow>
                                              </>
                                            ))
                                        )}
                                      </Mui.TableBody>
                                    </Mui.Table>
                                  </Mui.Box>
                                </Mui.TableContainer>
                              </Mui.Collapse>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        )}
                      </>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          <Mui.Box sx={{ mt: 1 }}>
            {shiftReports?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={shiftReports?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Mui.Box>
        </Mui.Grid>
      </Mui.Paper>
    </React.Fragment>
  );
};
